module.exports = __webpack_public_path__ + "media/images/webpage/hotels/743/plan2-3-c178f3d5fce16aeda43333e80e71bd81.webp";